// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `textarea {
    transition: height 0.2s;
    overflow-y: auto;
    max-height: 300px;
    min-height: 20px;
  }
  #dropdownTopButton {
    position: relative;
  }
  #dropdownTop {
    position: absolute;
    bottom: 68px;
    right: 40px;
    z-index: 10;
  }


  .send-button {
    opacity: 0;
    max-width: 0;
    overflow: hidden;
    transition: all 0.15s ease-in-out;
  }

  .send-button.show {
    max-width: 50px;
    opacity: 1;
  }
  .send-button:hover {
    transform: scale(1.1) translateY(-5px);
  }
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNoYXQtaW5wdXQuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLHVCQUF1QjtJQUN2QixnQkFBZ0I7SUFDaEIsaUJBQWlCO0lBQ2pCLGdCQUFnQjtFQUNsQjtFQUNBO0lBQ0Usa0JBQWtCO0VBQ3BCO0VBQ0E7SUFDRSxrQkFBa0I7SUFDbEIsWUFBWTtJQUNaLFdBQVc7SUFDWCxXQUFXO0VBQ2I7OztFQUdBO0lBQ0UsVUFBVTtJQUNWLFlBQVk7SUFDWixnQkFBZ0I7SUFDaEIsaUNBQWlDO0VBQ25DOztFQUVBO0lBQ0UsZUFBZTtJQUNmLFVBQVU7RUFDWjtFQUNBO0lBQ0Usc0NBQXNDO0VBQ3hDIiwiZmlsZSI6ImNoYXQtaW5wdXQuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbInRleHRhcmVhIHtcbiAgICB0cmFuc2l0aW9uOiBoZWlnaHQgMC4ycztcbiAgICBvdmVyZmxvdy15OiBhdXRvO1xuICAgIG1heC1oZWlnaHQ6IDMwMHB4O1xuICAgIG1pbi1oZWlnaHQ6IDIwcHg7XG4gIH1cbiAgI2Ryb3Bkb3duVG9wQnV0dG9uIHtcbiAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIH1cbiAgI2Ryb3Bkb3duVG9wIHtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgYm90dG9tOiA2OHB4O1xuICAgIHJpZ2h0OiA0MHB4O1xuICAgIHotaW5kZXg6IDEwO1xuICB9XG5cblxuICAuc2VuZC1idXR0b24ge1xuICAgIG9wYWNpdHk6IDA7XG4gICAgbWF4LXdpZHRoOiAwO1xuICAgIG92ZXJmbG93OiBoaWRkZW47XG4gICAgdHJhbnNpdGlvbjogYWxsIDAuMTVzIGVhc2UtaW4tb3V0O1xuICB9XG5cbiAgLnNlbmQtYnV0dG9uLnNob3cge1xuICAgIG1heC13aWR0aDogNTBweDtcbiAgICBvcGFjaXR5OiAxO1xuICB9XG4gIC5zZW5kLWJ1dHRvbjpob3ZlciB7XG4gICAgdHJhbnNmb3JtOiBzY2FsZSgxLjEpIHRyYW5zbGF0ZVkoLTVweCk7XG4gIH0iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/components/user-dashboard/chat-with-ai/partials/chat-input/chat-input.component.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;EACb;;;EAGA;IACE,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,sCAAsC;EACxC;AACF,owCAAowC","sourcesContent":["textarea {\n    transition: height 0.2s;\n    overflow-y: auto;\n    max-height: 300px;\n    min-height: 20px;\n  }\n  #dropdownTopButton {\n    position: relative;\n  }\n  #dropdownTop {\n    position: absolute;\n    bottom: 68px;\n    right: 40px;\n    z-index: 10;\n  }\n\n\n  .send-button {\n    opacity: 0;\n    max-width: 0;\n    overflow: hidden;\n    transition: all 0.15s ease-in-out;\n  }\n\n  .send-button.show {\n    max-width: 50px;\n    opacity: 1;\n  }\n  .send-button:hover {\n    transform: scale(1.1) translateY(-5px);\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
